function createSuggestionCard(item) {
  const imageUrl =
    item.images && item.images.length > 0
      ? item.images[0]
      : "https://via.placeholder.com/200x50";
  const name = item.name || "N/A";
  const alphaCode = item.alphaCode || "";

  return `
      <div class="suggestion-card">
        <div class="card-header">
          <strong>${alphaCode || name}</strong>
          ${
            alphaCode
              ? `<span class="in-catalog">${alphaCode} • In Catalog</span>`
              : ""
          }
        </div>
        <div class="card-image-box">
           <img src="${imageUrl}" alt="${name}" />
        </div>
      </div>
    `;
}

function createInfoPill(label, value, index, isPersonalDetails = false) {
  if (!value || value === "—") return "";

  let itemClass = "info-item";
  if (isPersonalDetails) {
    const colors = ["light-blue", "light-green", "light-purple", "light-yellow"];
    itemClass += ` ${colors[index % colors.length]}`;
  } else {
    itemClass += " info-item-white";
  }

  return `
      <div class="${itemClass}">
        <label>${label}</label>
        <span>${value}</span>
      </div>
    `;
}

export const printReportHTML = (data) => {
  const {
    capturedImage,
    mainProductImage,
    suggestions = [],
    userInfo = {},
    productInfo = {},
  } = data;

  const staticTeethImage = "https://collings-denture.s3.ap-southeast-2.amazonaws.com/collings-denture/1761291501420_screenshot_2025_10_24_at_1_06_34___pm.png";

  const suggestionGrid = suggestions
    .slice(0, 16)
    .map(createSuggestionCard)
    .join("");

  const personalDetailsItems = [
    createInfoPill("Full Name", userInfo.fullName, 0, true),
    createInfoPill("Email", userInfo.email, 1, true),
    createInfoPill("Phone", userInfo.phone, 2, true),
    createInfoPill("Age", userInfo.age, 3, true),
    createInfoPill("Gender", userInfo.gender, 4, true),
    createInfoPill(
      "Nostril Width",
      userInfo.nostrilWidth ? `${userInfo.nostrilWidth} mm` : "—",
      5,
      true
    ),
  ]
    .filter(Boolean)
    .join("");

  const productDetailsItems = [
    createInfoPill("Product", productInfo.name || productInfo.alphaCode, 0),
    createInfoPill("Vendor", productInfo.vendor, 1),
    createInfoPill("Shape", productInfo.shape, 2),
    createInfoPill("Case", productInfo.case, 3),
    createInfoPill("Color", productInfo.color, 4),
    createInfoPill(
      "Size (H × W)",
      productInfo.height && productInfo.width
        ? `${productInfo.height} × ${productInfo.width}`
        : "",
      5
    ),
    createInfoPill("Mass (g)", productInfo.mass, 6),
  ]
    .filter(Boolean)
    .join("");

  const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Denture Measurement Report</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
          
          body {
            font-family: 'Roboto', sans-serif;
            margin: 0;
            padding: 0;
            background: #ffffff;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          @page {
            size: A4 portrait;
            margin: 10mm;
          }
  
          .report-container {
            max-width: 100%;
            margin: 0 auto;
            background: #ffffff;
            padding: 5px;
          }

          .report-header {
            padding-bottom: 10px;
            margin-bottom: 15px;
            border-bottom: 1px solid #eee;
          }

          .report-header h1 {
            font-size: 24px;
            color: #111;
            margin: 0;
            text-align: center;
          }
  
          .top-images-section {
            display: flex;
            gap: 15px;
            padding-bottom: 10px;
            margin-bottom: 15px;
            page-break-inside: avoid;
          }
          .top-images-section .image-box {
            flex: 1;
            background: #fafafa;
            border: 1px solid #f0f0f0;
            border-radius: 8px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            align-items: center; 
          }
          .top-images-section .image-box h3 {
            margin-top: 0;
            margin-bottom: 10px;
            font-size: 14px;
            color: #333;
            text-align: center;
          }
          .top-images-section .image-box img {
            width: 60%; 
            height: auto;
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            margin-bottom: 10px;
          }

          .static-teeth-img {
            width: 50% !important; 
            border: none !important;
            background: transparent !important;
            margin-bottom: 15px;
          }

          .main-product-img {
            width: 90% !important; 
            border: none !important;
            background: transparent !important;
            margin-bottom: 15px;
          }

          .captured-face-img {
            width: 80% !important; 
            border: none !important;
            background: transparent !important;
            margin-bottom: 15px;
          }
  
          .suggestions-section {
            page-break-inside: avoid;
            margin-top: 15px; /* Added margin to separate from product details */
          }
          .suggestions-section h2 {
            font-size: 18px;
            color: #111;
            margin-bottom: 10px;
          }
          .suggestions-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
          }
          .suggestion-card {
            border: 1px solid #eee;
            border-radius: 8px;
            overflow: hidden;
            background: #fafafa;
            box-shadow: 0 1px 3px rgba(0,0,0,0.02);
            page-break-inside: avoid;
          }
          .suggestion-card .card-header {
            padding: 4px 6px;
            background: #f8f8f8;
            border-bottom: 1px solid #eee;
            font-size: 10px;
          }
          .suggestion-card .card-header strong {
            font-weight: 700;
            color: #333;
          }
          .suggestion-card .card-header span {
            background: #e4f3e4;
            color: #0d680d;
            font-weight: 500;
            padding: 1px 3px;
            border-radius: 4px;
            font-size: 9px;
            margin-left: 5px;
          }
          .suggestion-card .card-image-box {
             padding: 5px;
             background: #fff;
             display: flex;
             align-items: center;
             justify-content: center;
             min-height: 20px;
          }
          .suggestion-card .card-image-box img {
            width: 100%;
            height: auto;
            display: block;
          }
    
          .info-section {
             page-break-inside: avoid;
             margin-top: 15px; /* Added margin */
          }
           .info-section h2 {
            font-size: 18px;
            color: #111;
            margin-bottom: 10px;
          }
          
          .info-box {
            border-radius: 8px;
            padding: 10px;
            display: grid;
            gap: 10px;
          }
          
          .personal-details-box {
             background: #fdfdfd; 
             border: 1px solid #e0e8f3;
             padding: 15px;
             grid-template-columns: repeat(3, 1fr); /* 3 columns for patient info */
          }
          
          .product-details-box {
             background: #ffffff;
             border: 1px solid #f0f0f0;
             padding: 15px;
             grid-template-columns: repeat(5, 1fr); /* 3 columns for product details */
          }
  
          .info-item {
            font-size: 12px;
            border-radius: 6px;
            padding: 10px 12px;
          }
          
          .info-item-white {
             background: #ffffff;
             border: 1px solid #eef2f7;
             box-shadow: 0 1px 2px rgba(0,0,0,0.05);
          }
  
          .info-item label {
            display: block;
            font-size: 11px;
            color: #667;
            margin-bottom: 2px;
            font-weight: 500;
            text-transform: uppercase;
          }
          .info-item span {
            font-size: 14px;
            color: #111;
            font-weight: 700;
          }
  
          .light-blue { background-color: #e7f0fd; border: 1px solid #dbe6f7; }
          .light-green { background-color: #e6f8ef; border: 1px solid #d9f0e6; }
          .light-purple { background-color: #f5f2fd; border: 1px solid #e9e4f7; }
          .light-yellow { background-color: #fff6e9; border: 1px solid #faedda; }
    
          @media print {
            body {
              background: #ffffff;
              padding: 0;
              margin: 0;
            }
            .report-container {
              border: none;
              box-shadow: none;
              padding: 0;
              margin: 0;
              max-width: 100%;
            }
            .top-images-section, .suggestions-section, .info-section {
              page-break-inside: avoid;
            }
            @page {
               margin: 10mm;
            }
          }
        </style>
      </head>
      <body>
        <div class="report-container">

          <div class="report-header">
            <h1>Denture Measurement Report</h1>
          </div>
        
          <div class="top-images-section">
            <div class="image-box">
              <h3>Captured Face Snapshot</h3>
              <img src="${
                capturedImage || "https://via.placeholder.com/300"
              }" alt="Face Snapshot" class="captured-face-img">
            </div>
            <div class="image-box">
              <h3>Suitable Denture Type</h3>
              <img src="${staticTeethImage}" alt="Denture Type" class="static-teeth-img">
              <img src="${
                mainProductImage || "https://via.placeholder.com/300"
              }" alt="Main Product" class="main-product-img">
            </div>
          </div>

          <div class="info-section">
            <h2>Product Details</h2>
            <div class="info-box product-details-box">
              ${productDetailsItems}
            </div>
          </div>

          <div class="suggestions-section">
            <h2>Suggested Products</h2>
            <div class="suggestions-grid">
              ${suggestionGrid}
            </div>
          </div>
  
          <div class="info-section">
            <h2>Patient Information</h2>
            <div class="info-box personal-details-box">
              ${personalDetailsItems}
            </div>
          </div>
  
        </div>
      </body>
      </html>
    `;

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(htmlContent);
  doc.close();

  setTimeout(() => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (e) {
      console.error("Print failed:", e);
      alert("Print failed. Please allow pop-ups and try again.");
    }

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 2000);
  }, 1000);
};

